import React from 'react';

import BuildIcon from '@material-ui/icons/Build';

import { PERMISSAO_TELA_FREEZERS_LISTAR } from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuEquipamentos = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Equipamentos"
    icon={<BuildIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_FREEZERS_LISTAR] &&
      hasResource('equipamentos_freezer')}
  </SubMenu>
);

export default SubMenuEquipamentos;
